var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "highlight-box" },
    [
      _vm.type === "textarea"
        ? [
            _vm.value
              ? _c(
                  "div",
                  {
                    ref: "textareaOuter",
                    staticClass: "textarea-outer",
                    style: { height: _vm.maxHeight + "px" },
                  },
                  [
                    _c("div", {
                      ref: "outerInner",
                      staticClass: "outer-inner",
                      domProps: {
                        innerHTML: _vm._s(_vm.highlightHtml(_vm.value)),
                      },
                    }),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.value,
                  expression: "value",
                  modifiers: { trim: true },
                },
              ],
              ref: "textareaBox",
              style: { height: _vm.maxHeight + "px" },
              attrs: { placeholder: _vm.placeholder },
              domProps: { value: _vm.value },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.syncScrollTop($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.value = $event.target.value.trim()
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "input"
        ? [
            _vm.value
              ? _c("div", {
                  staticClass: "input-outer",
                  domProps: { innerHTML: _vm._s(_vm.highlightHtml(_vm.value)) },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.value,
                  expression: "value",
                  modifiers: { trim: true },
                },
              ],
              attrs: { type: "text", placeholder: _vm.placeholder },
              domProps: { value: _vm.value },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.value = $event.target.value.trim()
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }